import React from 'react';
import { Table } from 'antd';
const columns = [
  {
    title: 'Function Name',
    dataIndex: 'position',
    width: "150%",
  },
  {
    title: 'Total Downloads',
    dataIndex: 'downloads',
    width: '100%',
  },
];
const TopPositions = (props) => {
  const slicedArray = props.totalPositions.slice(0, 10);
  return (
    <Table
      className='wday-table'
      columns={columns}
      dataSource={slicedArray}
      pagination={false}
      size="small"
      scroll={{
        y: 220,
      }}
    />
  );
};

export default TopPositions;




